import { Lock } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Field, fieldInputCls } from "@/components/Field";
import { useSettings } from "@/context/SettingsContext";
import { useT } from "@/lib/i18n";
import { findTarget, fmtP } from "@/lib/pressureTargets";

export const setTyreModel = (s) => (s && (s.brand || s.model) ? { brand: s.brand || "", model: s.model || "" } : null);

export const TyreModelFields = ({ n, form, setForm, sets = [] }) => {
  const { t } = useT();
  const targets = useSettings().settings.tyre_targets || [];
  const bk = n === 1 ? "tyre_brand" : "tyre_brand2";
  const mk = n === 1 ? "tyre_model" : "tyre_model2";
  const inherited = setTyreModel(sets.find((s) => s.id === form[n === 1 ? "tyre_set_id" : "tyre_set2_id"]));
  const brand = inherited ? inherited.brand : form[bk];
  const model = inherited ? inherited.model : form[mk];
  const target = findTarget(targets, brand, model);
  const lockCls = inherited ? "!bg-[#10B981]/5 !text-slate-400 cursor-not-allowed !border-[#10B981]/40" : "";
  const lbl = (k) => (inherited ? <span className="inline-flex items-center gap-1">{t(k)} <Lock className="w-3 h-3 text-[#10B981]" /><span className="text-[#10B981] normal-case">{t("tyre_from_set")}</span></span> : t(k));
  const brands = [...new Set(targets.map((x) => x.brand))];
  const models = targets.filter((x) => !form[bk] || x.brand.toLowerCase() === form[bk].trim().toLowerCase()).map((x) => x.model);
  return (
    <div className="grid grid-cols-1 sm:grid-cols-[1fr_1fr_auto] gap-4 items-end">
      <Field label={lbl("tyre_brand")}>
        <Input data-testid={`stint${n}-tyre-brand-input`} list={`tyre-brands-${n}`} readOnly={!!inherited} title={inherited ? t("tyre_from_set_hint") : undefined} value={brand || ""} onChange={(e) => setForm((f) => ({ ...f, [bk]: e.target.value }))} className={`${fieldInputCls} ${lockCls}`} />
        <datalist id={`tyre-brands-${n}`}>{brands.map((b) => <option key={b} value={b} />)}</datalist>
      </Field>
      <Field label={lbl("tyre_model")}>
        <Input data-testid={`stint${n}-tyre-model-input`} list={`tyre-models-${n}`} readOnly={!!inherited} title={inherited ? t("tyre_from_set_hint") : undefined} value={model || ""} onChange={(e) => setForm((f) => ({ ...f, [mk]: e.target.value }))} className={`${fieldInputCls} ${lockCls}`} />
        <datalist id={`tyre-models-${n}`}>{models.map((m) => <option key={m} value={m} />)}</datalist>
      </Field>
      <div data-testid={`stint${n}-tyre-target`} className={`h-10 flex items-center gap-2 px-3 border rounded-sm font-mono text-xs whitespace-nowrap ${target ? "border-[#10B981]/50 text-[#10B981]" : "border-[#282D3D] text-slate-500"}`}>
        {target ? <>{t("tyre_target")}: <b>{fmtP(target.target, form.pressure_unit)} {form.pressure_unit}</b> ±{fmtP(target.tolerance, form.pressure_unit)}</> : t("no_target_short")}
      </div>
    </div>
  );
};
